import { render, staticRenderFns } from "./Changlang.vue?vue&type=template&id=707ae67a&"
import script from "./Changlang.vue?vue&type=script&lang=js&"
export * from "./Changlang.vue?vue&type=script&lang=js&"
import style0 from "./Changlang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports